import type { CSSProperties } from "react";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/v2/components/ui/button";
import { cn } from "@/v2/lib/utils";

export function BackButton({
  onClick,
  label = "Back",
  className,
  style,
}: {
  onClick: () => void;
  label?: string;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      onClick={onClick}
      style={style}
      className={cn(
        "gap-1.5 px-0 mb-2 text-xs font-semibold text-muted-foreground",
        className,
      )}
    >
      <ArrowLeft className="size-4" /> {label}
    </Button>
  );
}
